var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"my-4"},[_vm._v("Scanning book QR Code.")]),_c('b-progress',{attrs:{"value":100,"variant":"success","striped":"","animated":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }